import React, {useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPencilAlt, faTrashAlt, faAngleRight, faAnglesRight, faAnglesLeft, faAngleLeft} from '@fortawesome/free-solid-svg-icons';
import FactureUpdate from './FactureUpdate/FactureUpdate';
import {Row, Col} from 'react-bootstrap';
import NothingToDisplay from '../../NothingToDisplay';
import Spinner from '../../Spinner/Spinner';

/**
 * La vue qui gère les factures
 * @param {*} props props
 * @return {JSX}
 */
function FactureView(props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFacture, setSelectedFacture] = useState(null);
  const [isUpdate, setIsUpdate] = useState(true);
  const [isLoading, setIsLoading] = useState(false);


  const openModal = () => {
    document.getElementById('navbar').classList.add('navbar-hidden');
    document.body.classList.add('modal-open');
    setIsModalOpen(true);
  };

  const closeModal = () => {
    document.getElementById('navbar').classList.remove('navbar-hidden');
    document.body.classList.remove('modal-open');
    setIsModalOpen(false);
  };

  /**
   * @param {*} facture facture
   */
  function onClickUpdate(facture) {
    setIsUpdate(true);
    openModal();
    setSelectedFacture(facture);
  }

  return (
    <div className="chantier-container">
      {isLoading && <Spinner />}
      {isModalOpen && (
        <FactureUpdate isUpdate={isUpdate} selectedFacture={selectedFacture} setIsLoading={setIsLoading} closeModal={closeModal} setFactures={props.setFactures}/>
      )}
      <h2 className="facture-heading">Liste de fournisseurs</h2>
      <input
        type="text"
        value={props.searchInput}
        onChange={props.handleSearchInput}
        className="facture-input-hidden"
        placeholder="Barre de recherche" />
      <div className="facture-wrapper">
        <div className="facture-table">
          <div className="facture-search-container">
            <input
              type="text"
              value={props.searchInput}
              onChange={props.handleSearchInput}
              className="facture-input"
              placeholder="Barre de recherche" />
            <div className="facture-pagination-buttons">
              <button
                onClick={() => {
                  setIsUpdate(false);
                  openModal();
                }}
                key="+"
                className="facture-pagination-button">
                Ajouter
              </button>
              {[<FontAwesomeIcon key="1" icon={faAnglesLeft} />,
                <FontAwesomeIcon key="2" icon={faAngleLeft} />,
                <FontAwesomeIcon key="3" icon={faAngleRight} />,
                <FontAwesomeIcon key="4" icon={faAnglesRight} />].map((symbol, index) => {
                const newPage =
              index === 0 ?
                1 :
                index === 1 ?
                props.currentPage - 1 :
                index === 2 ?
                props.currentPage + 1 :
                Math.ceil(props.factures.length / props.pageSize);
                return (
                  <React.Fragment key={index}>
                    <button
                      key={symbol}
                      className="facture-pagination-button"
                      onClick={() => props.handlePageChange(newPage)}
                      disabled={props.isButtonDisabled(symbol)}>
                      {symbol}
                    </button>
                  </ React.Fragment>
                );
              })}
            </div>
          </div>
          {props.displayedFactures.length === 0 ? <NothingToDisplay /> :
      <div className="facture-table">
        <Row className="facture-row facture-header">
          <Col md={11} className="facture-cell">
            Factures
          </Col>
          <Col md={1} className="facture-cell">
          </Col>
        </Row>
        {props.displayedFactures.map((facture, index) => (
          <Row key={index} className="facture-row facture-row-cell-click" >
            <Col md={11} className="facture-cell facture-cell-click" data-title="Facture" >
              {facture.name}
            </Col>
            <Col md={1} className="facture-cell facture-cell-click">
              <FontAwesomeIcon className="facture-icon" style={{marginRight: '35px'}} icon={faPencilAlt}
                onClick={() => {
                  onClickUpdate(facture);
                }} />
              <FontAwesomeIcon className="facture-icon" icon={faTrashAlt} onClick={() => props.supprimer(facture)} />
            </Col>
          </Row>
        ))}
      </div>}
        </div>
      </div>
    </div>
  );
}

export default FactureView;
